import { DataModel } from '../../dto/dto.js';
import { LegacyOrderHook } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';

export abstract class OrderSideEffect extends DataModel {
  abstract get effectType(): OrderSideEffectType;
  abstract toLegacyOrderHook(): LegacyOrderHook | null;
}
